import { RouterProvider } from "react-router-dom";
import { StudyProvider } from "../state/StudyContext";
import { AppErrorBoundary } from "./AppErrorBoundary";
import { router } from "./router";

export function App() {
  return (
    <AppErrorBoundary>
      <StudyProvider>
        <RouterProvider router={router} />
      </StudyProvider>
    </AppErrorBoundary>
  );
}
